import { MegaShareFormTargetType } from "kz-ui-sdk";
import { MegaShareState } from "./mega-share-state";

export interface MegaShareParticipant {
  state: MegaShareState;
  takerInfo?: {
    value: string;
    type?: MegaShareFormTargetType;
  };
  giverInfo?: {
    value: string;
  };
}

export interface MegaShareContextState {
  giver: MegaShareParticipant;
  taker: MegaShareParticipant;
  claimAmount: number;
  instruction: Record<string, string>;
  remainingSeconds: number;
  targetTypes: MegaShareFormTargetType[];
}

export type MegaShareAction =
  | { type: "SET_GIVER"; payload: MegaShareParticipant }
  | { type: "SET_TAKER"; payload: MegaShareParticipant }
  | { type: "SET_CLAIM_AMOUNT"; payload: number }
  | { type: "SET_INSTRUCTION"; payload: Record<string, string> }
  | { type: "SET_REMAINING_SECONDS"; payload: number }
  | { type: "SET_TARGET_TYPES"; payload: MegaShareFormTargetType[] }
  | { type: "RESET" };

export const megaShareReducer = (state: MegaShareContextState, action: MegaShareAction): MegaShareContextState => {
  switch (action.type) {
    case "SET_GIVER":
      return { ...state, giver: action.payload };
    case "SET_TAKER":
      return { ...state, taker: action.payload };
    case "SET_CLAIM_AMOUNT":
      return { ...state, claimAmount: action.payload };
    case "SET_INSTRUCTION":
      return { ...state, instruction: action.payload };
    case "SET_REMAINING_SECONDS":
      return { ...state, remainingSeconds: action.payload };
    case "SET_TARGET_TYPES":
      return { ...state, targetTypes: action.payload };
    case "RESET":
      return initialMegaShareState;
    default:
      return state;
  }
};

export const initialMegaShareState: MegaShareContextState = {
  giver: {
    state: MegaShareState.LOADING,
  },
  taker: {
    state: MegaShareState.LOADING,
  },
  claimAmount: 0,
  instruction: {},
  remainingSeconds: 0,
  targetTypes: [MegaShareFormTargetType.PHONE_NUMBER],
};
